import { render, staticRenderFns } from "./CommonDescription.vue?vue&type=template&id=5ff12f16&scoped=true&"
import script from "./CommonDescription.vue?vue&type=script&lang=js&"
export * from "./CommonDescription.vue?vue&type=script&lang=js&"
import style0 from "./CommonDescription.vue?vue&type=style&index=0&id=5ff12f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff12f16",
  null
  
)

export default component.exports